// extracted by mini-css-extract-plugin
export var clouds = "hero-module--clouds--8d4f7";
export var dataGradient = "hero-module--dataGradient--f23b3";
export var fadeInUp = "hero-module--fadeInUp--a4df9";
export var hero = "hero-module--hero--f672f";
export var heroContent = "hero-module--heroContent--aea4a";
export var mockEdge = "hero-module--mockEdge--03cf1";
export var phone = "hero-module--phone--5e5fb";
export var phones = "hero-module--phones--6e895";
export var phonesHovered = "hero-module--phonesHovered--5f6f7";
export var phonesWrapper = "hero-module--phonesWrapper--32f34";
export var subtext = "hero-module--subtext--2c2ac";